var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47012 17.0001H17.5301C19.0701 17.0001 20.0301 15.3301 19.2601 14.0001L11.7301 0.990054C10.9601 -0.339946 9.04012 -0.339946 8.27012 0.990054L0.740121 14.0001C-0.0298788 15.3301 0.930121 17.0001 2.47012 17.0001ZM10.0001 10.0001C9.45012 10.0001 9.00012 9.55005 9.00012 9.00005V7.00005C9.00012 6.45005 9.45012 6.00005 10.0001 6.00005C10.5501 6.00005 11.0001 6.45005 11.0001 7.00005V9.00005C11.0001 9.55005 10.5501 10.0001 10.0001 10.0001ZM11.0001 14.0001H9.00012V12.0001H11.0001V14.0001Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.9918d8894c94bb280c6818f220da9450.svg";
export { ForwardRef as ReactComponent };